import { LOADING, ROLES } from "../actionType/roleManagementType";

const initialState = {
  loading: true,
  roles: [],
};

const roleManagementReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOADING:
      return { ...state, loading: payload };
    case ROLES:
      return { ...state, roles: payload };
    default:
      return state;
  }
};

export default roleManagementReducer;
